import React, { useContext as useContextCore } from 'react'
import type { UseDocumentResult } from '@ztechapps/common.hook'
import type { Project } from '@ztechapps/common.contract'

export type ProjectGantViewProviderProps = {
  projectDocumentResult: UseDocumentResult<Project>
  children: React.ReactNode
}

export type ProjectGantViewContext = Omit<ProjectGantViewProviderProps, 'children'>

const context = React.createContext<ProjectGantViewContext>({} as ProjectGantViewContext)
const CoreProvider = context.Provider

export const ProjectGantViewProvider = ({ children, ...props }: ProjectGantViewProviderProps) => {
  return <CoreProvider value={{ ...props }}>{children}</CoreProvider>
}

export const useProjectGantViewContext = () => useContextCore(context)
